import React from "react";
import {inject, observer} from "mobx-react";
import {observable, computed} from "mobx";
import {Box, Tab, Tabs} from "@material-ui/core";
import {IManagementStore} from "Stores/Management/types";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import PositionTeamsTable from "./PositionTeamsTable/PositionTeamsTable";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import {Values} from "@src/Tools/Values";
import {PositionTeam} from "@src/Interfaces/Entity/PositionTeam";
import {IAuthStore} from "@src/Stores/Auth/types";
import {STFormContentWrapper, STTabsContentWrapper} from "@src/Components/Pages/Main/Content/OAuth/styles";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import PositionTeamForm from "@src/Components/Pages/Main/Content/PositionTeams/PositionTeamForm/PositionTeamForm";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import {IValuesStore} from "Stores/Values/types";

interface IProps {
    management?: IManagementStore;
    values?: IValuesStore;
    auth?: IAuthStore;
}

@inject("auth", "management", "values")
@observer
class PositionTeamsContent extends React.Component<IProps> {
    @observable searchText: string = "";
    @observable showPositionTeamDialog: boolean = false;
    @observable editPositionTeam: PositionTeam = null;
    @observable isEdit: boolean = false;

    @computed get filteredPositionTeams() {
        return filterByTableColumns<PositionTeam>(
            this.props.management.positionTeams,
            this.searchText
        );
    }

    handleFilterChange(text: string) {
        this.searchText = text;
    };

    handleAddPositionTeamDialog() {
        this.editPositionTeam = new PositionTeam();
        this.editPositionTeam.state = this.props.values.states.Active;
        this.showPositionTeamDialog = true;
    }

    handleEditPositionTeamDialog(positionTeam: PositionTeam) {
        this.isEdit = true;
        this.showPositionTeamDialog = true;
        this.editPositionTeam = positionTeam;
    }

    async onSave(values: PositionTeam) {
        try {
            await this.props.management.savePositionTeam(values, !this.isEdit);
            this.onClose();
        } catch (error) {
            console.error(error);
        }
    }

    onClose() {
        this.showPositionTeamDialog = false;

        this.isEdit = false;
    }

    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <STTabsContentWrapper>
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant={"standard"}
                        >
                            <Tab label={Values.getLocalizationValue("positionTeams")}/>
                        </Tabs>
                    </STTabsContentWrapper>

                    {this.props.auth.user.location.primary &&
                        <AddButton
                            onClick={() => this.handleAddPositionTeamDialog()}
                            text={Values.getLocalizationValue("addPositionTeam")}
                        />
                    }
                </FullWidthFlexBox>

                <STFormContentWrapper>
                    <Box>
                        <FullWidthSearch
                            value={this.searchText}
                            onChange={(text: string) => this.handleFilterChange(text)}
                        />

                        {this.filteredPositionTeams.length > 0 ? (
                            <PositionTeamsTable
                                onEditButtonClick={(positionTeam) => this.handleEditPositionTeamDialog(positionTeam)}
                                positionTeams={this.filteredPositionTeams}
                            />
                        ) : (
                            <ResultsAreEmpty/>
                        )}
                    </Box>
                </STFormContentWrapper>

                <SimpleModal width={710} isOpened={this.showPositionTeamDialog} onClose={() => this.onClose()}>
                    <PositionTeamForm
                        title={Values.getLocalizationValue(this.isEdit ? "editPositionTeam" : "addPositionTeam")}
                        initialValues={this.editPositionTeam}
                        onClose={() => this.onClose()}
                        onSubmit={(positionTeam) => this.onSave(positionTeam)}
                    />
                </SimpleModal>
            </>
        );
    }
}

export default PositionTeamsContent;
